module.exports = __webpack_public_path__ + "static/media/real_vida.859a9564.png";